import React, { useEffect, useState } from 'react';

type EmailsAnalyzedProps = {
  emailsNumber: number;
};

export const EmailsAnalyzed: React.FC<EmailsAnalyzedProps> = ({
  emailsNumber,
}: EmailsAnalyzedProps): JSX.Element => {
  const [currentNumber, setCurrentNumber] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentNumber((prevNumber) =>
        prevNumber < emailsNumber ? prevNumber + 1 : emailsNumber
      );
    }, 5);
    if (currentNumber === emailsNumber) clearInterval(interval);
    return () => clearInterval(interval);
  });

  return <div className="table__emails-analyzed">{currentNumber} emails</div>;
};
